import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { UpdateDocumentAdditionalData, DOCUMENT_LOCATION_UPDATE } from "./UpdateDocumentAdditionalData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { Location } from "../../../../../models/Location";

export const updateDocumentLocationActionTypes = createRequestActionTypes('UPDATE_DOCUMENT_LOCATION')

export const updateDocumentLocation = (config: ApiConfig) => (docId: string, newLocation: Location | null) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const body = newLocation ? newLocation : {
        geoLocation: null,
        locationAddress: ""
    }

    const thunkParams: RequestThunkParameters<Document, any, UpdateDocumentAdditionalData> = {
        method: 'POST',
        requestActionTypes: updateDocumentLocationActionTypes,
        url: `${config.API_URL}/content/update-location?id=${encodeURIComponent(docId)}`,
        actionAdditionalData: {
            docId,
            updateInfo: {
                type: DOCUMENT_LOCATION_UPDATE,
                data: newLocation
            }
        },
        body
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}